import { HttpErrorResponse } from '@angular/common/http';
import { ApiException, ApiExceptionConstructor } from 'src/core/common/domain/exceptions/api-exception';

export class InvalidCredentialsException extends ApiException implements ApiExceptionConstructor {
  constructor(message?: string, error?: HttpErrorResponse | Error) {
    super(message, error);
    this.name = 'InvalidCredentialsException';
  }

  static fromError(error: HttpErrorResponse | Error): InvalidCredentialsException {
    return new this(error.message, error);
  }
}
